import regexForm from '../../utils/regexForm';

const {
    adress,
    cityRegion,
    country,
    email,
    firstname,
    lastname,
    name,
    organisationName,
    phone,
    password,
    url,
    zipCode,
} = regexForm;

const subscriptionInputsPatterns = [
    {
        name: 'organisationName',
        pattern: organisationName,
        type: 'text',
        required: true,
    },
    {
        name: 'lastname',
        pattern: lastname,
        type: 'text',
        required: true,
    },
    {
        name: 'firstname',
        pattern: firstname,
        type: 'text',
        required: true,
    },
    {
        name: 'email',
        pattern: email,
        type: 'email',
        required: true,
    },
    {
        name: 'phone',
        pattern: phone,
        type: 'tel',
        required: true,
    },
    {
        name: 'password',
        pattern: password,
        type: 'password',
        required: true,
    },
    {
        name: 'passwordVerify',
        pattern: password,
        type: 'password',
        required: true,
    },
    {
        name: 'country',
        pattern: country,
        type: 'text',
        required: true,
    },
    {
        name: 'organisationWebsite',
        pattern: url,
        type: 'url',
        required: false,
    },
];

const subscriptionCharityInputsPatterns = [
    {
        name: 'associationName',
        pattern: name,
        type: 'text',
        required: true,
    },
    {
        name: 'representativeLastname',
        pattern: lastname,
        type: 'text',
        required: true,
    },
    {
        name: 'firstname',
        pattern: firstname,
        type: 'text',
        required: true,
    },
    {
        name: 'email',
        pattern: email,
        type: 'email',
        required: true,
    },
    {
        name: 'phone',
        pattern: phone,
        type: 'tel',
        required: true,
    },
    {
        name: 'password',
        pattern: password,
        type: 'password',
        required: true,
    },
    {
        name: 'passwordVerify',
        pattern: password,
        type: 'password',
        required: true,
    },
    {
        name: 'address',
        pattern: adress,
        type: 'text',
        required: true,
    },
    {
        name: 'zipCode',
        pattern: zipCode,
        type: 'text',
        required: true,
    },
    {
        name: 'city',
        pattern: cityRegion,
        type: 'text',
        required: true,
    },
    {
        name: 'country',
        pattern: country,
        type: 'text',
        required: true,
    },
    {
        name: 'website',
        pattern: url,
        type: 'url',
        required: true,
    },
];

export { subscriptionInputsPatterns, subscriptionCharityInputsPatterns };
